'use client'

import { ButtonHTMLAttributes, FC } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen: boolean
}

const BurgerButton: FC<ButtonProps> = ({ isOpen, onClick }) => {
  return (
    <button onClick={onClick} aria-label={isOpen ? 'Menü schließen' : 'Menü öffnen'} type="button" className="w-[23px] h-[23px] flex justify-around items-center flex-col z-10 cursor-pointer">
      <div className={`bg-white block w-[23px] h-0.5 rounded transition-all origin-[1px] ${isOpen ? 'rotate-45' : 'rotate-0'}`} />
      <div className={`bg-white block w-[23px] h-0.5 rounded transition-all origin-[1px] ${isOpen ? 'opacity-0 bg-transparent' : 'opacity-100'}`} />
      <div className={`bg-white block w-[23px] h-0.5 rounded transition-all origin-[1px] ${isOpen ? '-rotate-45' : 'rotate-0'}`} />
    </button>
  )
}

export default BurgerButton
